import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KeyCheckin, KeyCheckout } from '@type/keys.type';
import { SelectOption } from '@type/select.type';
import { Vehicle } from '@type/vehicle.type';
import { Observable } from 'rxjs';
import { PaginationHelper } from '../helper/pagination.helper';
import { Page } from '@type/page.type';
import { Confirmation } from 'primeng/api';
import { Yard } from '@type/yard.type';
import { QueryHelper } from '../helper/query.helper';

@Injectable({
  providedIn: 'root',
})
export class KeyService {
  selectedYard: Yard;

  clearConfirmation: Confirmation = {
    header: 'Clear all',
    message: 'Are you sure you want to clear all entered data and start over?',
    rejectButtonProps: {
      label: 'Cancel',
      severity: 'secondary',
    },
    acceptButtonProps: {
      label: 'Clear',
    },
  };

  constructor(private http: HttpClient) { }

  checkin(keyCheckin: KeyCheckin): Observable<void> {
    return this.http.post<void>('keys/checkin', keyCheckin);
  }

  getCheckinResourcesVehicle(vin: string): Observable<Vehicle> {
    return this.http.get<Vehicle>(`keys/checkin/resources/vehicles/vins/${vin}`);
  }

  getCheckinResourcesUsers(): Observable<SelectOption[]> {
    return this.http.get<SelectOption[]>('keys/checkin/resources/users');
  }

  getCheckinResourcesYards(): Observable<SelectOption[]> {
    return this.http.get<SelectOption[]>('keys/checkin/resources/yards');
  }

  getCheckinResourcesBins(yardId: number): Observable<SelectOption[]> {
    return this.http.get<SelectOption[]>(`keys/checkin/resources/yards/${yardId}/bins`);
  }

  checkout(keyCheckout: KeyCheckout): Observable<void> {
    return this.http.post<void>('keys/checkout', keyCheckout);
  }

  getCheckoutResourcesVehicles(
    page: number,
    params: {
      vin?: string,
      yardId?: number,
      excludeYardId?: number,
    } = {},
    pageSize = 5,
  ): Observable<Page<Vehicle>> {
    let queryParams = PaginationHelper.getPageQueryParams(page, pageSize);

    queryParams = QueryHelper.mergeQueryParams([
      queryParams,
      new HttpParams({
        fromObject: params,
      }),
    ]);

    return this.http.get<Page<Vehicle>>(`keys/checkout/resources/vehicles?${queryParams.toString()}`);
  }

  getCheckoutResourcesUsers(): Observable<SelectOption[]> {
    return this.http.get<SelectOption[]>('keys/checkout/resources/users');
  }
}
